var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "p",
      { staticClass: "typographies-heading-h3 plugin-summary__content-title" },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Mes modules supplémentaires")) +
            "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "plugins-list" },
      _vm._l(_vm.pluginsEnabled, function(plugin) {
        return _c("plugin-item", { key: plugin.id, attrs: { plugin: plugin } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }